export const GROUP_TYPE = {
  CUSTOM: 'custom',
  VIRTUAL: 'virtual'
};

export const MAIN_GROUP_TYPE = {
  COLLECTION: 'collection',
  PHYSICAL: 'physical',
  VIRTUAL: 'virtual'
};

export const MAIN_TYPE_OPTIONS = [
  {
    value: 'virtual',
    label: 'Virtual'
  },
  {
    value: 'physical',
    label: 'Physical'
  },
  {
    value: 'collection',
    label: 'Collection'
  }
];
